import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./style.css";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Service from "../../../services/Service";
import { useSelector } from "react-redux";

const OurBoard = () => {
	const prevButRef = useRef(null);
	const nextButRef = useRef(null);
	const [isBeginning, setIsBeginning] = useState(true);
	const [isEnd, setIsEnd] = useState(false);
	const [data, setData] = useState([]);
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);

	useEffect(() => {
		new Service().getList("ourBoard").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data?.data;
				if (!!response?.length) {
					setData(response);
				}
			}
		});
	}, []);

	return (
		<div className="our-board" id="our-board">
			<div className="container">
				<p className="title">{t("Our Board")}</p>
				<div className="position-relative">
					<div className="d-flex swiper-buttons position-absolute justify-content-end gap-16">
						<button className="button-prev" ref={prevButRef}>
							<svg
								width="54"
								height="54"
								viewBox="0 0 54 54"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M27.0002 0.333496C12.3068 0.333496 0.333496 12.3068 0.333496 27.0002C0.333496 41.6935 12.3068 53.6668 27.0002 53.6668C41.6935 53.6668 53.6668 41.6935 53.6668 27.0002C53.6668 12.3068 41.6935 0.333496 27.0002 0.333496ZM31.7735 35.0002C32.5468 35.7735 32.5468 37.0535 31.7735 37.8268C31.3735 38.2268 30.8668 38.4135 30.3602 38.4135C29.8535 38.4135 29.3468 38.2268 28.9468 37.8268L19.5335 28.4135C18.7602 27.6402 18.7602 26.3602 19.5335 25.5868L28.9468 16.1735C29.7202 15.4002 31.0002 15.4002 31.7735 16.1735C32.5468 16.9468 32.5468 18.2268 31.7735 19.0002L23.7735 27.0002L31.7735 35.0002Z"
									fill={isBeginning ? "#C2C3C3" : "#9C1121"}
								/>
							</svg>
						</button>
						<button className="button-next" ref={nextButRef}>
							<svg
								width="54"
								height="54"
								viewBox="0 0 54 54"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M27.0002 0.333496C12.3068 0.333496 0.333496 12.3068 0.333496 27.0002C0.333496 41.6935 12.3068 53.6668 27.0002 53.6668C41.6935 53.6668 53.6668 41.6935 53.6668 27.0002C53.6668 12.3068 41.6935 0.333496 27.0002 0.333496ZM34.4402 28.4135L25.0268 37.8268C24.6268 38.2268 24.1202 38.4135 23.6135 38.4135C23.1068 38.4135 22.6002 38.2268 22.2002 37.8268C21.4268 37.0535 21.4268 35.7735 22.2002 35.0002L30.2002 27.0002L22.2002 19.0002C21.4268 18.2268 21.4268 16.9468 22.2002 16.1735C22.9735 15.4002 24.2535 15.4002 25.0268 16.1735L34.4402 25.5868C35.2402 26.3602 35.2402 27.6402 34.4402 28.4135Z"
									fill={!isEnd ? "#9C1121" : "#C2C3C3"}
								/>
							</svg>
						</button>
					</div>
					<Swiper
						slidesPerView={1}
						onInit={(swiper) => {
							swiper.params.navigation.prevEl = prevButRef.current;
							swiper.params.navigation.nextEl = nextButRef.current;
							swiper.navigation.init();
							swiper.navigation.update();
						}}
						onSlideChange={(swiper) => {
							setIsBeginning(swiper.isBeginning);
							setIsEnd(swiper.isEnd);
						}}
						scrollbar={{ draggable: true }}
						modules={[Navigation]}
						className="mySwiper">
						{data?.map((person, index) => {
							return (
								<SwiperSlide key={index}>
									<div className="board" data-aos="zoom-in">
										<img src={person?.image} alt="person" />
										<div className="details">
											<p className="name">{person[`name_${lang}`]}</p>
											<p className="job">{person[`job_title_${lang}`]}</p>
											<p className="description">
												{index === 0 && (
													<svg
														width="40"
														height="40"
														viewBox="0 0 40 40"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M2.95947 33.3254C2.95947 34.9317 4.26043 36.2329 5.86667 36.2329H15.3156C16.9219 36.2329 18.223 34.9317 18.223 33.3254V21.6961C18.223 20.0897 16.9219 18.7887 15.3156 18.7887H10.6493C9.84219 18.7887 9.19571 18.1345 9.19571 17.3351C9.19571 17.0734 9.26091 16.8917 9.26091 16.8917C10.322 13.3736 13.0037 10.5536 16.4419 9.30359L16.4563 9.28903C17.496 8.84583 18.2229 7.81343 18.2229 6.61407C18.2229 5.00791 16.9218 3.70679 15.3155 3.70679C14.923 3.70679 14.5526 3.78663 14.2112 3.92463L14.0796 3.97583C7.57451 6.51231 2.95947 12.8359 2.95947 20.2423V33.3254ZM21.8573 33.3254C21.8573 34.9317 23.1583 36.2329 24.7646 36.2329H34.2136C35.8198 36.2329 37.1208 34.9317 37.1208 33.3254V21.6961C37.1208 20.0897 35.8198 18.7887 34.2136 18.7887H29.5472C28.7401 18.7887 28.0936 18.1345 28.0936 17.3351C28.0936 17.0661 28.1587 16.8917 28.1587 16.8917C29.22 13.3736 31.9016 10.5536 35.3399 9.30359L35.3543 9.28903C36.3939 8.84583 37.1208 7.81343 37.1208 6.61407C37.1208 5.00791 35.8198 3.70679 34.2136 3.70679C33.8211 3.70679 33.4505 3.78663 33.1092 3.92463L32.9776 3.97583C26.4724 6.51231 21.8573 12.8359 21.8573 20.2423V33.3254Z"
															fill="#9C1121"
														/>
													</svg>
												)}{" "}
												<span
													dangerouslySetInnerHTML={{
														__html: person[`description_${lang}`],
													}}></span>{" "}
												{index === 0 && (
													<svg
														width="40"
														height="40"
														viewBox="0 0 40 40"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M37.0405 33.3254C37.0405 34.9317 35.7396 36.2329 34.1333 36.2329H24.6844C23.0781 36.2329 21.777 34.9317 21.777 33.3254V21.6961C21.777 20.0897 23.0781 18.7887 24.6844 18.7887H29.3507C30.1578 18.7887 30.8043 18.1345 30.8043 17.3351C30.8043 17.0734 30.7391 16.8917 30.7391 16.8917C29.678 13.3736 26.9963 10.5536 23.5581 9.30359L23.5437 9.28903C22.504 8.84583 21.7771 7.81343 21.7771 6.61407C21.7771 5.00791 23.0782 3.70679 24.6845 3.70679C25.077 3.70679 25.4474 3.78663 25.7888 3.92463L25.9204 3.97583C32.4255 6.51231 37.0405 12.8359 37.0405 20.2423V33.3254ZM18.1427 33.3254C18.1427 34.9317 16.8417 36.2329 15.2354 36.2329H5.78645C4.18021 36.2329 2.87925 34.9317 2.87925 33.3254V21.6961C2.87925 20.0897 4.18021 18.7887 5.78645 18.7887H10.4528C11.2599 18.7887 11.9064 18.1345 11.9064 17.3351C11.9064 17.0661 11.8413 16.8917 11.8413 16.8917C10.78 13.3736 8.09837 10.5536 4.66013 9.30359L4.64573 9.28903C3.60613 8.84583 2.87925 7.81343 2.87925 6.61407C2.87925 5.00791 4.18021 3.70679 5.78645 3.70679C6.17893 3.70679 6.54949 3.78663 6.89085 3.92463L7.02237 3.97583C13.5276 6.51231 18.1427 12.8359 18.1427 20.2423V33.3254Z"
															fill="#9C1121"
														/>
													</svg>
												)}
											</p>
										</div>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</div>
			</div>
		</div>
	);
};
export default OurBoard;
